import { useNuxtApp, useRuntimeConfig } from "nuxt/app";
import Medusa from "@medusajs/js-sdk";
import { cacheMedusaPublicReads } from "#shared/lib/cache-medusa-public-reads";
import { usePublicDataRequest } from "./public-data-request";
import { withMedusaReadTimeout } from "./medusa-read-timeout";

export const useMedusaClient = (): Medusa => {
  const nuxtApp = useNuxtApp();

  const { medusaUrl, medusaToken } = useRuntimeConfig().public;

  // Create client if it is not there.
  if (!nuxtApp._medusaClient) {
    const medusa = new Medusa({
      baseUrl: medusaUrl as string,
      publishableKey: medusaToken as string,
    });
    if (import.meta.server) {
      cacheMedusaPublicReads(medusa.client, usePublicDataRequest(), medusaUrl as string);
      const client = medusa.client;
      client.fetch_ = withMedusaReadTimeout(client.fetch_.bind(client));
    }
    nuxtApp._medusaClient = medusa;
  }

  return nuxtApp._medusaClient as Medusa;
};

export function useClickAndCollectSalesChannelId(): string {
  const value = useRuntimeConfig().public.clickAndCollectSalesChannelId;
  const salesChannelId = typeof value === "string" ? value.trim() : "";

  if (!salesChannelId) {
    throw new Error(
      "Не настроен канал продаж для самовывоза. Обратитесь в поддержку магазина.",
    );
  }

  return salesChannelId;
}
export function usePublicSalesChannelId(): string {
  const value = useRuntimeConfig().public.salesChannelId;
  const salesChannelId = typeof value === "string" ? value.trim() : "";

  if (!salesChannelId) {
    throw new Error(
      "Не настроен канал продаж по умолчанию. Обратитесь в поддержку магазина.",
    );
  }

  return salesChannelId;
}
